module.exports = __webpack_public_path__ + "static/img/lounge.e42c008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/lounge.jpg
// module id = jFoY
// module chunks = 0